import React from "react";
import useCivilEFilePayment from "./useCivilEFilePayment";
import Fetch from "../../../../common/payment-config-form/Fetch";
import AcceptHosted from "../../../../common/payment-config-form/AcceptHosted";

const PaymentForm = ({ ...props }) => {
  const { authorizeSandbox } = useCivilEFilePayment();
  return <Fetch amount={props.amount} paymentType="civil">{(response) => <AcceptHosted type={"iframe"} mode={!authorizeSandbox ? "production" : "sandbox"} formToken={response} amount={props.amount} isCivil={true} />}</Fetch>;
};

export default PaymentForm;
